import { IComponentOptions } from 'angular';
import { WizardController } from './wizard.controller';
import template from './wizard.component.html';

export const WizardComponent = {
	bindings: {
		onComplete: '&onComplete',
		onEnd: '&onEnd',
		onRevisit: '&onRevisit',
		onStart: '&onStart',
		views: '=views'
	},
	controller: WizardController,
	template
} as IComponentOptions;
